<template>
  <v-container>
    <!--(팝업)전체 기업 목록-->
    <!--(팝업)기업 생성-->
    <v-dialog
      v-model="addCpn"
      @keydown.esc="closeAddCpn()"
      max-width="1200"
      persistent
    >
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          기업 생성
          <v-btn fab class="popBtnClose" @click="closeAddCpn()"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text class="scrollYst addCpn_scrollCon">
          <v-row no-gutters class="popCon scrollYst_con">
            <div class="dot_tt16 ">기업 생성 신청 안내</div>
            <div class="popCon_txt mt-0 row_mb-40">
              글로싸인엔터프라이즈에서 기업계약을 진행하려면 기업 블록체인
              주소가 생성되어야 합니다.<br />
              최초 생성된 기업 블록체인 주소는 온라인 기업 인증을 거쳐 사용할 수
              있습니다.
            </div>
            <div class="dot_tt16">온라인 기업 인증 안내</div>
            <div class="popCon_txt mt-0 row_mb-20">
              글로싸인엔터프라이즈에서는 고객 편의를 위하여 온라인 기업 인증을
              제공하며, 이때 최초 1회의 사업자용 공인인증서 인증을 요청 드리고
              있습니다.<br />
              이는 전자계약 과정과는 관계없이 실제 기업 여부를 확인하기 위한
              용도로, 신청인 및 신청 기업 확인을 위한 대면 확인과 원본 서류
              제출을 대신합니다.<br />
              온라인 기업 인증이 완료되면 기업 생성을 신청하신 회원이 기업
              관리자로 등록되며, 해당 기업의 모든 계약관리 권한을 가집니다.
            </div>
            <div class="txtst_info_gray row_mb-8">
              - 신청 기업의 사업자용 인증서를 확인해 주세요.
            </div>
            <v-col cols="12" class="bg_ulScard">
              <ul class="pattern_ulScard">
                <li>
                  <div class="st_tt">한국무역정보통신</div>
                  <span class="st_txt">법인 범용</span>
                  <span class="st_txt">스마트빌 전용</span>
                </li>
                <li>
                  <div class="st_tt">한국정보인증</div>
                  <span class="st_txt">법인 범용</span>
                  <span class="st_txt">스마트빌 전용</span>
                </li>
                <li>
                  <div class="st_tt">코스콤(구한국증권전산)</div>
                  <span class="st_txt">법인 범용</span>
                </li>
                <li>
                  <div class="st_tt">한국정보보호진흥원</div>
                  <span class="st_txt">특별등급</span>
                </li>
                <li>
                  <div class="st_tt">한국전산원</div>
                  <span class="st_txt">법인 범용</span>
                </li>
                <li>
                  <div class="st_tt">금융결제원</div>
                  <span class="st_txt">법인 범용</span>
                </li>
                <li>
                  <div class="st_tt">한국전자인증</div>
                  <span class="st_txt">법인 범용</span>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn
            class="btn_C01"
            text
            @click="(addCpn = false), (addCpn01 = true)"
            >기업 정보 등록</v-btn
          >
          <v-btn text @click="closeAddCpn()">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <!--(팝업)기업 생성-1 기업 정보 등록-->
    <v-dialog
      v-model="addCpn01"
      @keydown.esc="closeAddCpn()"
      max-width="800"
      persistent
    >
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          기업 정보 등록
          <v-btn fab class="popBtnClose"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text class="scrollYst addCpn_scrollCon">
          <v-row no-gutters class="popCon scrollYst_con">
            <v-col cols="12" class="popCon_input_W100_cov pd-0">
              <v-text-field
                class="inputH48_01 conBstar row_mb-8"
                label="기업명"
                ref="organizationName"
                v-model="formOrg.organizationName"
                value="formOrg.organizationName"
                :rules="rules.organizationRequireRules"
                placeholder="기업명을 입력해 주세요"
                outlined
              >
              </v-text-field>
              <div class="inputH48_left_btn_before">
                <v-text-field
                  class="inputH48_01 conBstar row_mb-8"
                  label="사업자등록번호"
                  ref="organizationRegistrationNumber"
                  v-model="formOrg.organizationRegistrationNumber"
                  value="formOrg.organizationRegistrationNumber"
                  :rules="rules.orgRegnoRequireRules"
                  placeholder="사업자등록번호를 입력해 주세요"
                  maxlength="10"
                  outlined
                >
                </v-text-field>
              </div>
              <v-btn outlined class="btn17_00" @click="isValidRegNum"
                >기업 등록 확인</v-btn
              >
              <span
                v-if="
                  this.formOrg.organizationRegistrationNumber !== '' &&
                    this.isCheckRegNum ===
                      this.formOrg.organizationRegistrationNumber &&
                    this.validateRegNumStatus === 0
                "
                class="el-form-item__error"
                style="color:dodgerblue"
                >기업등록이 가능합니다</span
              >
              <v-text-field
                class="inputH48_01 conBstar row_mb-8"
                label="대표자"
                ref="presidentName"
                v-model="formOrg.presidentName"
                value="formOrg.presidentName"
                :rules="rules.nameRequireRules"
                placeholder="대표자를 입력해 주세요"
                outlined
              >
              </v-text-field>
              <v-text-field
                class="inputH48_01 W100 conBstar row_mb-8"
                label="주소"
                ref="organizationAddress"
                v-model="formOrg.organizationAddress"
                v-value="formOrg.organizationAddress"
                :rules="rules.addressRequireRules"
                placeholder="사업장 주소를 입력해 주세요"
                outlined
              >
              </v-text-field>
              <v-text-field
                class="inputH48_01"
                label="연락처"
                v-model="formOrg.organizationContact"
                value="formOrg.organizationContact"
                :rules="rules.organizationContactRules"
                placeholder="사업장 연락처를 입력해 주세요"
                outlined
              >
              </v-text-field>
              <div class="inputH48_left_btn_before">
                <v-text-field
                  class="inputH48_01"
                  label="프로모션코드"
                  v-model="formOrg.promotionCode"
                  value="formOrg.promotionCode"
                  :rules="rules.promotionCodeRules"
                  placeholder="프로모션코드를 입력해 주세요"
                  outlined
                >
                </v-text-field>
              </div>
              <v-btn outlined class="btn17_00" @click="checkPromotionCode"
                >프로모션코드 확인</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn class="btn_C01" text @click="registComInfo()"
            >기업 정보 등록</v-btn
          >
          <v-btn text @click="closeAddCpn()">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <!--/(팝업)기업 생성-1 기업 정보 등록-->
    <!--(팝업)기업 생성-2 기업 블록체인 주소 생성-->
    <v-dialog
      v-model="addCpn02"
      @keydown.esc="closeAddCpn()"
      max-width="800"
      persistent
    >
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          <!--팝업 텍스트 스텝에 따라 변경
            생성 전: 기업 블록체인 주소 생성 / 생성 후: 블록체인 주소 생성 완료-->
          기업 블록체인 주소 생성
          <v-btn fab class="popBtnClose"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="popCon">
            <!--생성 전-->
            <div class="popCon_txt">
              {{ this.formOrg.organizationName }}({{
                this.formOrg.organizationRegistrationNumber | regNumFilter
              }}) 님의 기업 블록체인 주소를 생성합니다.
            </div>
            <div class="popCon_input_W100_cov">
              <v-text-field
                class="inputH48_01 conBstar"
                ref="passwordRules"
                label="블록체인 비밀번호"
                v-model="formOrgBc.password"
                value="formOrgBc.password"
                :rules="rules.passwordRules"
                type="password"
                messages="영어, 숫자 포함 6~12자리로 입력"
                outlined
              >
              </v-text-field>
              <v-text-field
                class="inputH48_01 conBstar"
                ref="passwordreRules"
                label="블록체인 비밀번호 확인"
                v-model="formOrgBc.password_re"
                value="formOrgBc.password_re"
                :rules="rules.passwordreRules"
                type="password"
                messages="영어, 숫자 포함 6~12자리로 입력"
                outlined
              >
              </v-text-field>
            </div>
            <ul class="pattern_ul_terms">
              <li>- 신규 생성하시는 기업 블록체인 주소입니다.</li>
              <li>
                <span class="fc_C05"
                  >- 블록체인 비밀번호 분실시 글로싸인엔터프라이즈에서 비밀번호
                  찾기 또는 초기화 할 수 없습니다.<br />비밀번호를 정확히
                  기억하시기 바랍니다</span
                >
              </li>
            </ul>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <!--버튼 텍스트 스텝에 따라 변경
            생성 전: 블록체인 주소 생성 / 생성 후: 온라인 기업 인증 신청-->
          <v-btn class="btn_C01 mb_max_180" text @click="createOrg()"
            >블록체인 주소 생성</v-btn
          >
          <v-btn text @click="closeAddCpn()">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addCpn03"
      @keydown.esc="closeAddCpn()"
      max-width="800"
      persistent
    >
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          <!--팝업 텍스트 스텝에 따라 변경
            생성 전: 기업 블록체인 주소 생성 / 생성 후: 블록체인 주소 생성 완료-->
          블록체인 주소 생성 완료
          <v-btn fab class="popBtnClose"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="popCon">
            <!--생성 후-->
            <div class="popCon_txt">기업 블록체인 주소가 생성되었습니다.</div>
            <v-row no-gutters class="feepay_round_box row_mt-20 row_mb-20">
              <v-col cols="12" class="posiR">
                <ul class="pattern_ulTxtBox">
                  <li>
                    <v-chip class="conFrom st_cpn">기업</v-chip>
                    <span class="txt_txt01 no_pr">{{
                      this.tempOrgInfo.organizationName
                    }}</span>
                    <span class="txt_txt02"
                      >{{ this.tempOrgInfo.organizationName }}({{
                        this.tempOrgInfo.organizationRegistrationNumber
                          | regNumFilter
                      }})</span
                    >
                  </li>
                  <li>
                    <span class="txt_tt">{{
                      this.tempOrgInfo.chainAddress
                    }}</span>
                  </li>
                </ul>
              </v-col>
            </v-row>
            <ul class="pattern_ul_terms">
              <li>
                온라인 기업 인증이 완료되어야 기업 블록체인을 이용한 전자계약
                이용이 가능합니다.<br />온라인 기업 인증을 완료해 주세요.
              </li>
            </ul>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <!--버튼 텍스트 스텝에 따라 변경
            생성 전: 블록체인 주소 생성 / 생성 후: 온라인 기업 인증 신청-->
          <v-btn class="btn_C01" text @click="requestJoinOrg()"
            >온라인 기업 인증 신청</v-btn
          >
          <v-btn text @click="closeAddCpn()">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <!--/(팝업)기업 생성-2 기업 블록체인 주소 생성-->
    <v-dialog
      v-model="addCpn04"
      @keydown.esc="closeAddCpn()"
      max-width="800"
      persistent
    >
      <v-card>
        <iframe
          v-if="this.orgJoinRequestVisible"
          width="100%"
          height="1000"
          :src="getAuthurl()"
        ></iframe>
      </v-card>
    </v-dialog>
    <!--/(팝업)기업 생성-3 기업 인증 신청-->
    <!--/(팝업)기업 생성-->
    <pubCert
      ref="pubCert"
      :cert-regno="
        tempOrgInfo ? tempOrgInfo.organizationRegistrationNumber : ''
      "
      @childs-event="purCertResult"
    ></pubCert>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
    <!--/(팝업)전체 기업 목록-->
  </v-container>
</template>

<script>
import { orgNumSearchList } from "@/api/join";
import {
  checkPromotionCode,
  updateOrgAdminUser,
  createTempOrg,
  joinRequestOrginfo,
  authOrg
} from "@/api/orgconfig";
import pubCert from "@/components/pubCertCompany";

export default {
  name: "addCpn",
  components: {
    pubCert
  },
  props: {
    authUrl: String
  },
  computed: {
    upperPromotionCode: {
      get() {
        return this.formOrg.promotionCode.toUpperCase();
      },
      set(val) {
        this.formOrg.promotionCode = val.toUpperCase();
      }
    }
  },
  watch: {},
  filters: {
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    }
  },
  data() {
    return {
      rules: {
        organizationRequireRules: [v => !!v || "기업명을 입력해주세요."],
        orgRegnoRequireRules: [
          v => !!v || "사업자번호를 입력해주세요.",
          v => (v && v.length === 10) || "사업자등록번호는 10자리입니다.",
          v => /^[0-9]*$/.test(v) || "숫자만 입력해주세요."
        ],
        nameRequireRules: [v => !!v || "대표자명을 입력하세요."],
        addressRequireRules: [v => !!v || "주소지를 입력해주세요."],
        organizationContactRules: [
          v =>
            (/^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})([0-9]{7,8})$/.test(v) &&
              v.length !== 0) ||
            "연락처를 정확히 입력해주세요"
        ],
        passwordRules: [
          v => !!v || "비밀번호를 입력해 주세요",
          v =>
            /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,12}$/.test(v) ||
            "영어, 숫자 포함하여 6~12자리로 입력해 주십시요"
        ],
        passwordreRules: [
          v => !!v || "비밀번호를 입력해 주세요",
          v =>
            /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,12}$/.test(v) ||
            "영어, 숫자 포함하여 6~12자리로 입력해 주십시요",
          v =>
            this.formOrgBc.password === this.formOrgBc.password_re ||
            "비밀번호가 일치하지않습니다"
        ]
      },
      addFn: false,
      validateRegNumStatus: 0,
      isCheckRegNum: "",
      // 기업 생성
      addCpn: false,
      addCpn01: false,
      addCpn02: false,
      addCpn03: false,
      addCpn04: false,
      orgJoinRequestVisible: false,
      formOrg: {
        organizationName: "",
        organizationRegistrationNumber: "",
        presidentName: "",
        organizationAddress: "",
        organizationContact: "",
        promotionCode: ""
      },
      formSearchReqGroupOrg: {
        organizationSequence: "",
        organizationName: "",
        organizationRegistrationNumber: "",
        presidentName: "",
        organizationAddress: "",
        organizationContact: ""
      },
      // 프로모션코드 체크 여부
      isPromotionCode: false,
      formOrgBc: {
        password: "",
        password_re: ""
      },
      tempOrgInfo: {},
      UsrSeq: ""
    };
  },
  created() {},
  mounted() {
    window.addEventListener("message", this.closeAuthPopup, true);
  },
  methods: {
    open() {
      this.addCpn = true;
    },
    isValidRegNum() {
      var regChecks = "^[0-9]*$";
      if (this.formOrg.organizationRegistrationNumber === "") {
        this.$refs.confirm.open(
          "alert",
          "기업생성",
          "사업자 번호를 입력하세요"
        );
      } else if (
        !this.formOrg.organizationRegistrationNumber.match(regChecks)
      ) {
        this.$refs.confirm.open("alert", "기업생성", "숫자만 입력하세요");
      } else if (this.formOrg.organizationRegistrationNumber.length !== 10) {
        this.$refs.confirm.open(
          "alert",
          "기업생성",
          "사업자 번호는 10자리입니다"
        );
      } else {
        this.validateRegNumStatus = 0;
        orgNumSearchList(
          JSON.stringify({
            regNum: this.formOrg.organizationRegistrationNumber
          })
        ).then(Response => {
          if (Response.rdata.rcode === 20000) {
            if (Response.rdata.orguserCount > 0) {
              this.isCheckRegNum = "";
              this.validateRegNumStatus = 1;
              this.$refs.confirm
                .open(
                  "confirm",
                  "관리자 등록",
                  "이미 등록된 기업입니다. 기업 참여 요청을 하시겠습니까?"
                )
                .then(() => {
                  var tempRegNum = this.formOrg.organizationRegistrationNumber;
                  this.initDialog();
                  this.searchReqRegNum = tempRegNum;
                  this.editContrctEmail.mail = "";
                  this.orginfoGroupReqVisible = true;
                });
            } else {
              this.isCheckRegNum = "";
              this.validateRegNumStatus = 1;
              if (Response.rdata.resultCode === 1) {
                this.$refs.confirm
                  .open(
                    "confirm",
                    "관리자 등록",
                    "기존의 등록된 기업정보가 있습니다. 해당 기업의 관리자로 연결하시겠습니까?"
                  )
                  .then(() => {
                    this.updateOrgAdminUser(
                      Response.rdata.orginfo.organizationSequence
                    );
                  });
              } else {
                this.$refs.confirm.open(
                  "alert",
                  "기업생성",
                  "인증 심사 중인 기업입니다. 인증 완료 후 가입요청을 하시거나, 고객센타로 문의 바랍니다."
                );
              }
            }
          } else {
            this.isCheckRegNum = this.formOrg.organizationRegistrationNumber;
          }
        });
      }
    },
    checkPromotionCode() {
      if (!this.formOrg.promotionCode) {
        this.$refs.confirm.open(
          "alert",
          "프로모션",
          "프로모션코드를 입력해주세요."
        );
        return;
      }
      this.$refs.loading.start("프로모션코드 확인 중");
      checkPromotionCode({ promotionCode: this.formOrg.promotionCode })
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.isPromotionCode = true;
            this.$refs.confirm.open(
              "alert",
              "프로모션",
              "유효한 프로모션코드입니다."
            );
          } else {
            this.isPromotionCode = false;
            this.$refs.confirm.open(
              "alert",
              "프로모션",
              response.rdata.message
            );
          }
        })
        .catch(e => {
          this.$refs.loading.end();
          this.isPromotionCode = false;
          this.$refs.confirm.open(
            "alert",
            "프로모션",
            "프로모션코드 확인에 실패했습니다. 이 메시지가 지속되면 관리자에게 문의해주세요."
          );
        });
    },
    updateOrgAdminUser(organizationSequence) {
      this.$refs.loading.start("입력 정보 확인 중");
      updateOrgAdminUser({ organizationSequence: organizationSequence }).then(
        Response => {
          if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
            this.$refs.loading.end();
            this.initDialog();
            this.$refs.confirm.open(
              "alert",
              "관리자 등록",
              "기업 관리자 등록이 완료되었습니다."
            );
          } else {
            this.$refs.loading.end();
            this.initDialog();
            var msg = "";
            if (Response.rdata === undefined) {
              msg = Response.message;
            } else {
              msg = Response.rdata.message;
            }
            this.$refs.confirm.open("alert", "관리자 등록", msg);
          }
        }
      );
    },
    // 기업 생성 함수
    createOrg() {
      if (
        this.$refs.passwordRules.validate() &&
        this.$refs.passwordreRules.validate()
      ) {
        this.$refs.confirm
          .open(
            "confirm",
            "기업생성",
            "블록체인 생성후에는 비밀번호 찾기 또는  초기화를 할 수 없습니다. 비밀번호를 정확히 기억하시기 바랍니다."
          )
          .then(() => {
            this.createTempOrg();
          });
      } else {
        this.$refs.confirm.open(
          "alert",
          "기업생성",
          "비밀번호 형식을 확인 해주세요."
        );
      }
    },
    createTempOrg() {
      this.tempOrgInfo = "";
      this.UsrSeq = "";
      this.createOrgArg = this.formOrg;
      this.createOrgArg.password = this.formOrgBc.password;
      this.$refs.loading.start("입력 정보 확인 중");
      createTempOrg({ org: this.createOrgArg }).then(Response => {
        if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
          this.$refs.loading.end();
          this.initDialog();
          this.tempOrgInfo = Response.rdata.orginfo;
          this.UsrSeq = Response.rdata.UsrSeq;
          this.addCpn02 = false;
          this.addCpn03 = true;
        } else {
          this.$refs.loading.end();
          this.initDialog();
          var msg = "";
          if (Response.rdata === undefined) {
            msg = Response.message;
          } else {
            msg = Response.rdata.message;
          }
          this.addCpn02 = false;
          this.$refs.confirm.open("alert", "기업생성", msg);
        }
      });
    },
    // 기업 인증신청 팝업 생성
    requestJoinOrg() {
      this.$refs.pubCert.open();
    },
    purCertResult(result) {
      this.$refs.loading.start("기업인증 중입니다. 잠시만 기다려주세요.");
      authOrg({
        chainPass: this.chainPass,
        pubkey: result.certPEM,
        rValue: result.rValue,
        signValue: result.signValue,
        hashValue: result.hashValue,
        companyName: result.username
      })
        .then(response => {
          this.$refs.loading.end();
          if (response.rcode === 20000 && response.rdata.success) {
            this.$refs.confirm
              .open("alert", "기업인증", "기업인증이 완료되었습니다.")
              .then(() => {
                if (process.env.NODE_ENV === "development") {
                  window.location = "http://localhost:8088/main";
                } else {
                  window.location = process.env.VUE_APP_REQUEST_URL + "/main";
                }
              });
          } else {
            this.$refs.confirm
              .open(
                "alert",
                "기업인증",
                "기업인증에 실패했습니다. (ERR : " +
                  response.rdata.message +
                  ")"
              )
              .then(() => {
                if (process.env.NODE_ENV === "development") {
                  window.location = "http://localhost:8088/main";
                } else {
                  window.location = process.env.VUE_APP_REQUEST_URL + "/main";
                }
              });
          }
        })
        .catch(() => {
          this.$refs.loading.end();
          this.$refs.confirm
            .open("alert", "기업인증", "기업인증에 실패했습니다.")
            .then(() => {
              location.reload();
            });
        });
    },
    registComInfo() {
      if (
        this.$refs.organizationName.validate() &&
        this.$refs.organizationRegistrationNumber.validate() &&
        this.$refs.presidentName.validate() &&
        this.$refs.organizationAddress.validate()
      ) {
        if (
          this.isCheckRegNum === this.formOrg.organizationRegistrationNumber &&
          this.validateRegNumStatus === 0
        ) {
          if (this.formOrg.promotionCode !== "") {
            if (!this.isPromotionCode) {
              this.$refs.confirm.open(
                "alert",
                "기업생성",
                "프로모션코드 유효성 여부를 확인해주세요"
              );
            } else {
              this.addCpn01 = false;
              this.addCpn02 = true;
            }
          } else {
            this.addCpn01 = false;
            this.addCpn02 = true;
          }
        } else {
          this.$refs.confirm.open(
            "alert",
            "기업생성",
            "기업등록 확인을 해주세요."
          );
        }
      } else {
        this.$refs.confirm.open(
          "alert",
          "기업생성",
          "기업정보를 확인해주세요."
        );
      }
    },
    getAuthurl() {
      var urls = "";
      if (
        this.tempOrgInfo !== undefined &&
        this.tempOrgInfo !== null &&
        this.tempOrgInfo !== ""
      ) {
        urls = this.authUrl;
        urls =
          urls +
          "?orgRegNo=" +
          this.tempOrgInfo.organizationRegistrationNumber +
          "&orgSeq=" +
          this.tempOrgInfo.organizationSequence +
          "&usrSeq=" +
          this.UsrSeq;
      }
      return urls;
    },
    closeAuthPopup(e) {
      if (
        e.data.auth !== undefined &&
        this.orgJoinRequestVisible &&
        this.addFn
      ) {
        this.addFn = false;
        if (e.data.auth === "true") {
          this.reqAuthCheck();
        } else {
          this.initDialog();
        }
      }
    },
    initDialog() {
      this.formOrg.organizationName = "";
      this.formOrg.organizationRegistrationNumber = "";
      this.formOrg.presidentName = "";
      this.formOrg.organizationAddress = "";
      this.formOrg.organizationContact = "";
      this.formOrg.organizationEmail = "";
      this.formOrg.promotionCode = "";
      this.formOrgBc.password = "";
      this.formOrgBc.password_re = "";

      this.isPromotionCode = false;
      this.addCpn01 = false;
      this.addCpn02 = false;
      this.addCpn03 = false;
      this.addCpn04 = false;
      this.orgJoinRequestVisible = false;
      this.orgConfigPage = 1;
    },
    reqAuthCheck() {
      this.$refs.loading.start("입력 정보 확인 중");
      joinRequestOrginfo({}).then(Response => {
        if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
          this.$refs.loading.end();
          if (Response.rdata.isEnableOrg) {
            this.tempOrgInfo = "";
            this.UsrSeq = "";
            this.$refs.confirm.open(
              "alert",
              "기업 인증",
              "요청하신 기업 인증이 완료되었습니다."
            );
            this.getOrgList();
          } else {
            this.tempOrgInfo = Response.rdata.tempOrg;
            this.UsrSeq = Response.rdata.UsrSeq;
            this.addCpn04 = true;
            this.orgJoinRequestVisible = true;
          }
        } else {
          this.$refs.loading.end();
          var msg = "인증기업 조회에 실패하였습니다. 고객센터로 문의하세요.";
          if (Response.rdata === undefined) {
            msg = Response.message;
          } else {
            msg = Response.rdata.message;
          }
          this.$refs.confirm.open("alert", "기업 인증", msg);
          this.getOrgList();
        }
      });
    },
    closeAddCpn() {
      this.$refs.confirm
        .open("confirm", "기업 생성", "기업 생성을 취소하시겠습니까?")
        .then(() => {
          location.reload();
        });
    }
  }
};
</script>
